/**
 * Площадки, с которых умеем забирать запись по ссылке.
 *
 * 🔴 Источник правды один — `ALLOWED_HOSTS` в `bit-fetch/app/config.py`. Пока
 * список жил прямо в разметке панели настроек, он разошёлся с бэкендом и
 * обещал ВКонтакте, выключённый 25.05.2026 (серверная выкачка упирается в
 * логин, редирект на login.vk.com), а про поддержанные ok.ru и kinescope.io
 * молчал. Человек вставлял ссылку на ВК, получал отказ и решал, что сломано.
 *
 * Добавили площадку в bit-fetch — добавьте сюда: расхождение молчаливое, его
 * ловит только тест в `videoPlatforms.test.js`.
 */

/**
 * Хосты ровно как в bit-fetch ALLOWED_HOSTS (без вариантов www./m.).
 * Облачные диски — CLOUD_DISK_HOSTS там же: ссылка на файл, не на папку.
 */
export const VIDEO_HOSTS = [
  'youtube.com',
  'youtu.be',
  'rutube.ru',
  'ok.ru',
  'vimeo.com',
  'dailymotion.com',
  // Короткие ссылки Dailymotion: бэкенд принимал их всегда, а фронт отвечал
  // «не понимаю ссылку» — расхождение нашла сверка с config.py (29.09.2026).
  'dai.ly',
  'soundcloud.com',
  'kinescope.io',
  'disk.yandex.ru',
  'disk.yandex.com',
  'disk.360.yandex.ru',
  // Ссылка «Поделиться» в Яндекс 360 для бизнеса — на .com (01.10.2026).
  'disk.360.yandex.com',
  'yadi.sk',
  // Своим резолвером в bit-fetch (cloud_mail.py): у yt-dlp экстрактора нет.
  'cloud.mail.ru',
  'drive.google.com',
  'dropbox.com',
];

/** Подпись под полем ссылки — человеческими именами, в порядке частоты. */
export const SUPPORTED_VIDEO_PLATFORMS =
  'YouTube · Rutube · Kinescope · Одноклассники · Vimeo · Dailymotion · SoundCloud'
  + ' · Яндекс Диск · Облако Mail.ru · Google Диск · Dropbox';

/** Короткая подсказка внутри поля: первые три и многоточие. */
export const VIDEO_PLATFORMS_HINT = 'Вставьте ссылку: YouTube, Rutube, Яндекс Диск…';
